(function () {
function bwInit() {
document.querySelectorAll('[data-bw-root]').forEach(function (root) {
if (root.dataset.init) return;
root.dataset.init = '1';
var $ = function (s, el) { return (el || root).querySelector(s); };
var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };

var slides = $$('[data-slide]'), thumbs = $$('[data-thumb]'), cur = 0;
function show(i) {
  if (!slides.length) return;
  cur = (i + slides.length) % slides.length;
  slides.forEach(function (s, n) { s.classList.toggle('is-active', n === cur); });
  thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === cur); });
}
thumbs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });
if ($('[data-prev]')) $('[data-prev]').addEventListener('click', function () { show(cur - 1); });
if ($('[data-next]')) $('[data-next]').addEventListener('click', function () { show(cur + 1); });

$$('[data-track-wrap]').forEach(function (sec) {
  var track = $('[data-track]', sec); if (!track) return;
  var step = function () { var c = track.firstElementChild; return c ? c.getBoundingClientRect().width + 18 : 300; };
  var pv = $('[data-track-prev]', sec), nx = $('[data-track-next]', sec);
  if (pv) pv.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
  if (nx) nx.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
});

$$('[data-eta]').forEach(function (el) {
  var lang = document.documentElement.lang || 'en';
  function plus(n) { var d = new Date(), c = 0; while (c < n) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) c++; } return d; }
  function fmt(d) { try { return d.toLocaleDateString(lang, { day: 'numeric', month: 'short' }); } catch (e) { return d.toDateString().slice(4, 10); } }
  var tpl = el.dataset.tpl || '{start} – {end}';
  el.textContent = tpl.replace('{start}', fmt(plus(+el.dataset.min || 11))).replace('{end}', fmt(plus(+el.dataset.max || 17)));
});
$$('[data-avail-toggle]').forEach(function (b) {
  var panel = b.parentNode.querySelector('[data-avail-panel]');
  b.addEventListener('click', function () { var open = panel.hidden; panel.hidden = !open; b.setAttribute('aria-expanded', open); });
});

var dataEl = $('[data-product]');
if (!dataEl) return;
var P = JSON.parse(dataEl.textContent);
var tiers = $$('[data-tier]');
var active = tiers[0];
function findVariant(opts) { return P.variants.filter(function (v) { return v.options.join('|') === opts.join('|'); })[0]; }
function unitVariant(row) {
  var sels = $$('select', row);
  if (!sels.length) return P.variants[0];
  return findVariant(sels.map(function (s) { return s.value; }));
}
function units() {
  if (active.dataset.variant) { var bv = P.variants.filter(function (v) { return v.id === +active.dataset.variant; })[0]; return [bv]; }
  var rows = $$('[data-unit]', active);
  if (rows.length) return rows.map(unitVariant);
  var q = +active.dataset.qty || 1, out = [];
  for (var i = 0; i < q; i++) out.push(P.variants[0]);
  return out;
}
var atcBtn = $('[data-atc]');
atcBtn.dataset.label = atcBtn.textContent.trim();
function render() {
  var ok = units().every(function (v) { return v && v.available; });
  atcBtn.disabled = !ok;
  atcBtn.textContent = ok ? atcBtn.dataset.label : (atcBtn.dataset.soldout || 'Sold out');
}
var gift = $('[data-gift]'), giftCheck = gift && $('[data-gift-check]', gift), giftWanted = false;
function syncGift() {
  if (!gift) return;
  var free = tiers.indexOf(active) + 1 === +gift.dataset.freeTier;
  gift.classList.toggle('is-free', free);
  giftCheck.disabled = free;
  giftCheck.checked = free || giftWanted;
  $$('[data-gift-paid]', gift).forEach(function (el) { el.hidden = free; });
  $$('[data-gift-free]', gift).forEach(function (el) { el.hidden = !free; });
}
if (giftCheck) giftCheck.addEventListener('change', function () { giftWanted = giftCheck.checked; });
function pick(t) {
  if (t === active) return;
  tiers.forEach(function (x) { x.classList.toggle('is-active', x === t); x.setAttribute('aria-checked', x === t); });
  active = t; render(); syncGift();
}
tiers.forEach(function (t) {
  t.addEventListener('click', function (e) { if (!e.target.closest('select')) pick(t); });
  t.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && e.target === t) { e.preventDefault(); pick(t); } });
});
$$('[data-unit] select').forEach(function (s) { s.addEventListener('change', render); });

atcBtn.addEventListener('click', function () {
  var counts = {};
  units().forEach(function (v) { if (v) counts[v.id] = (counts[v.id] || 0) + 1; });
  var items = Object.keys(counts).map(function (id) { return { id: +id, quantity: counts[id] }; });
  if (giftCheck && giftCheck.checked) items.push({ id: +gift.dataset.giftVariant, quantity: 1 });
  $$('[data-addon]', active).forEach(function (ad) { if ($('[data-addon-check]', ad).checked) items.push({ id: +ad.dataset.addonVariant, quantity: 1 }); });
  var msg = $('[data-msg]'); msg.hidden = true;
  atcBtn.disabled = true; atcBtn.textContent = atcBtn.dataset.adding || 'Adding…';
  var r0 = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  fetch(r0 + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
    .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || 'Could not add to cart'); return j; }); })
    .then(function () { window.location.href = r0 + (P.redirect === 'checkout' ? 'checkout' : 'cart'); })
    .catch(function (err) { msg.textContent = err.message; msg.hidden = false; atcBtn.disabled = false; atcBtn.textContent = atcBtn.dataset.label; });
});
render(); syncGift();
});
}
bwInit();
document.addEventListener('shopify:section:load', bwInit);
})();
